import { render, staticRenderFns } from "./common-mobilephone.vue?vue&type=template&id=9872f7c4"
import script from "./common-mobilephone.vue?vue&type=script&lang=js"
export * from "./common-mobilephone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports